import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]


export default /*#__PURE__*/_defineComponent({
  __name: 'TruncateString',
  props: {
  string: {
    type: String,
    default: '',
    required: true,
  },
  maxLength: {
    type: Number,
    default: 30,
  },
},
  setup(__props) {

const props = __props;

/**
 * This component accepts a string prop and, if the string is longer than the
 * maxLength prop, truncates the string to that max length followed by '...'. If
 * truncated it adds a title to the string element so the user can see the
 * original value on hover.
 */


function truncateString (string: string) {
  if (string.length > props.maxLength) {
    return `${string.substring(0, props.maxLength - 3)}...`
  }
  return string
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    title: 
      truncateString(props.string) === props.string
        ? undefined
        : props.string
    
  }, _toDisplayString(truncateString(props.string)), 9, _hoisted_1))
}
}

})